<template>
  <b-row class="p-0">
    <b-col :md="columns" class="mb-4" v-for="job in jobs" :key="job.id">
      <job-item :job="job" />
    </b-col>
  </b-row>
</template>

<script>
import JobItem from '@/components/cards/JobItem'

export default {
  props: {
    jobs: {
      type: Array,
      default: () => []
    },

    columns: {
      type: Number,
      default: 4
    }
  },

  components: {
    JobItem
  }
}
</script>

<style lang="scss" scoped></style>
